module.exports = __webpack_public_path__ + "static/media/side-profile-tile-icon.988b4e95.svg";